import { useEffect, useState } from 'react'

import {
  getWardrobeCatalogs,
  getUserItemFacets,
  transformWardrobeCatalogDtosWithCounts,
  WardrobeCatalogWithParentIdModel,
} from '@marketplace-web/profile/profile-data'

type Props = {
  userId: number
}

const useFetchWardrobeCatalogs = ({ userId }: Props) => {
  const [catalogs, setCatalogs] = useState<Array<WardrobeCatalogWithParentIdModel>>([])

  useEffect(() => {
    const fetchUserItemFacets = async () => {
      const [catalogsResponse, userItemFacetsResponse] = await Promise.all([
        getWardrobeCatalogs(),
        getUserItemFacets({ userId }),
      ])

      if ('errors' in catalogsResponse || 'errors' in userItemFacetsResponse) {
        setCatalogs([])

        return
      }

      const availableCatalogs = transformWardrobeCatalogDtosWithCounts(
        catalogsResponse.catalogs,
        userItemFacetsResponse.catalogs,
      )

      setCatalogs(availableCatalogs)
    }

    fetchUserItemFacets()
  }, [userId])

  return {
    catalogs,
  }
}

export default useFetchWardrobeCatalogs
